import { isEmpty } from "lodash";
import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useDeepEffect } from "../../abstracts";
import SearchBar from "../../containers/Mapper/LoadDefHomeContainer/SearchBar";

const FeeApplicableToAddedPlansCard = (props) => {
  const {
    setAddedPlansFilter,
    searchAddedPlans,
    setSearchAddedPlans,
    addedPlans,
    setPlans,
    addedPlansFilter,
    plans,
    setPlanListFilter,
    planListFilter,
    setAddedPlans,
    searchPlanList,
    error,
    setFilteredPlans,
    isExclude,
  } = props;

  const [noMatchesFound, setNoMatchesFound] = useState(false);

  useDeepEffect(() => {
    if (!isEmpty(addedPlans)) {
      setAddedPlansFilter(
        addedPlans?.filter((team) => {
          return (
            team.planName
              .toLowerCase()
              .includes(searchAddedPlans.toLowerCase()) ||
            team.rkPlanNumber.includes(searchAddedPlans)
          );
        })
      );
    }
  }, [searchAddedPlans]);

  useDeepEffect(() => {
    if (!isEmpty(searchAddedPlans) && isEmpty(addedPlansFilter)) {
      setNoMatchesFound(true);
    } else {
      setNoMatchesFound(false);
    }
  }, [searchAddedPlans, addedPlansFilter]);

  const removeAllPlans = () => {
    setPlans([...addedPlansFilter, ...plans]);
    var list = addedPlansFilter.filter((team) => {
      return (
        team.planName.toLowerCase().includes(searchPlanList.toLowerCase()) ||
        team.rkPlanNumber.includes(searchPlanList)
      );
    });
    setPlanListFilter([...list, ...planListFilter]);
    setFilteredPlans([...list, ...planListFilter]);
    var temp = addedPlans.filter(
      (plan) =>
        !addedPlansFilter?.map((item) => item.planId).includes(plan.planId)
    );
    setAddedPlans(temp);
    setAddedPlansFilter([]);
  };

  const removePlansFromPlanGroup = (data) => {
    setAddedPlans(addedPlans.filter((e) => e.planId !== data.planId));
    setAddedPlansFilter(
      addedPlansFilter.filter((e) => e.planId !== data.planId)
    );
    setPlans((e) => [data, ...e]);

    setPlanListFilter((e) => [data, ...e]);
    setFilteredPlans((e) => [data, ...e]);
  };
  return (
    <div className="fee-maintenancePlanRight">
      <div className="maintenancePlanRight-1 padding-10">
        <div className="fee-header-font marg-top-15 marg-bot-15  ">
          {isExclude ? "Excluded " : "Added "}plans
        </div>
        <div className="searchbar-width">
          <Form>
            <div className="flex-search">
              <InputGroup>
                <InputGroup.Prepend>
                  <div className="searchIconPostion-fee">
                    <i class="fal fa-search" aria-hidden="true"></i>
                  </div>
                </InputGroup.Prepend>
                <SearchBar
                  size="sm"
                  type="search"
                  placeholder="Search plan name & ID"
                  onChange={(e) => setSearchAddedPlans(e.target.value)}
                  className="PadLeftSearch"
                />
              </InputGroup>
            </div>
          </Form>
        </div>

        <div className="plan-group-remove-count">
          <div className="plan-group-remove">
            <p
              className="link red-small mb-0"
              style={{ cursor: "pointer" }}
              onClick={() => removeAllPlans()}
            >
              Remove all
            </p>
          </div>
          <div className="plan-group-plan" style={{ paddingLeft: "200px" }}>
            {addedPlansFilter.length} Plans
          </div>
        </div>

        {isEmpty(addedPlans) ? (
          <>
            {!noMatchesFound && (
              <div className="plan-group-no-plan">
                <div className="plan-no-plan">
                  No plans {isExclude ? "excluded" : "added"}
                </div>
                <div className="plan-add-plan">
                  Please add plans here by clicking on the arrow
                </div>
                <div className="red-small mt-15 mleft-5r"> {error} </div>
              </div>
            )}
          </>
        ) : (
          <>
            {addedPlansFilter?.map((data, index) => (
              <div className="fee-plan-card mt-20">
                <div className="card-top">
                  <div className="d-flex justify-content-space-between">
                    <div className="fee-header-card-font">
                      Plan ID: {data.rkPlanNumber}
                    </div>

                    <p
                      className="removelink-font mb-0"
                      style={{ cursor: "pointer" }}
                      onClick={() => removePlansFromPlanGroup(data)}
                    >
                      Click to remove X
                    </p>
                  </div>
                </div>
                <div className="fee-body-card-font ml-10 mt-10">
                  {data.planName}
                </div>
                {data.planStatus === 0 && (
                  <div className="underconstuction-backgd">
                    <div className="underconstuction-font">
                      UnderConstruction
                    </div>
                  </div>
                )}
                {data.planStatus === 1 && (
                  <div className="readyforapproval-backgd">
                    <div className="readyforapproval-font">
                      ReadyForApproval
                    </div>
                  </div>
                )}
                {data.planStatus === 2 && (
                  <div className="approved-backgd">
                    <div className="approved-font">Approved</div>
                  </div>
                )}
                {data.planStatus === 3 && (
                  <div className="active-backgd d-flex">
                    <div className="active-font">Active</div>
                  </div>
                )}
                {data.planStatus === 4 && (
                  <div className="inactive-backgd d-flex">
                    <div className="inactive-font">InActive</div>
                  </div>
                )}
                {data.planStatus === 5 && (
                  <div className="terminated-backgd d-flex">
                    <div className="terminated-font">Terminated</div>
                  </div>
                )}
              </div>
            ))}
          </>
        )}
        {noMatchesFound && (
          <div className="fee-bodyfilter-font mleft-8r mt-6r">
            No matches found
          </div>
        )}
      </div>
    </div>
  );
};

export default FeeApplicableToAddedPlansCard;
